/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const dbGetItem = /* GraphQL */ `
  query DbGetItem($db: String!, $dbVariables: AWSJSON!) {
    dbGetItem(db: $db, dbVariables: $dbVariables) {
      statusState
      statusMessage
      statusItem
      __typename
    }
  }
`;
export const getMessage = /* GraphQL */ `
  query GetMessage($clientId: String!, $messageId: String!) {
    getMessage(clientId: $clientId, messageId: $messageId) {
      messageId
      note
      status
      position
      createdAt
      __typename
    }
  }
`;
export const getPriceIncrease = /* GraphQL */ `
  query GetPriceIncrease($client: String!, $years: [String!]) {
    getPriceIncrease(client: $client, years: $years)
  }
`;
export const getPriceIncreaseList = /* GraphQL */ `
  query GetPriceIncreaseList($client: String!) {
    getPriceIncreaseList(client: $client) {
      year
      amount
      __typename
    }
  }
`;
export const getR0001Reportv2 = /* GraphQL */ `
  query GetR0001Reportv2(
    $endDate: AWSDate!
    $startDate: AWSDate!
    $stores: [String]
  ) {
    getR0001Reportv2(
      endDate: $endDate
      startDate: $startDate
      stores: $stores
    ) {
      id
      startDate
      endDate
      shifts {
        shift
        store {
          name
          kpis {
            kpi
            low
            mid
            top
            actualPercent
            actualValue
            percentRank
            percentToMid
            percentToTop
            valueRank
            valueToMid
            valueToTop
            subRows {
              kpi
              low
              mid
              top
              actualPercent
              actualValue
              percentRank
              percentToMid
              percentToTop
              valueRank
              valueToMid
              valueToTop
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const getR0003ProjectionData = /* GraphQL */ `
  query GetR0003ProjectionData($week: String!, $store: String!) {
    getR0003ProjectionData(week: $week, store: $store) {
      week
      store
      avgWage
      monProjSales
      monProjAvgCheck
      monSchedFOH
      monSchedBOH
      tueProjSales
      tueProjAvgCheck
      tueSchedFOH
      tueSchedBOH
      wedProjSales
      wedProjAvgCheck
      wedSchedFOH
      wedSchedBOH
      thuProjSales
      thuProjAvgCheck
      thuSchedFOH
      thuSchedBOH
      friProjSales
      friProjAvgCheck
      friSchedFOH
      friSchedBOH
      satProjSales
      satProjAvgCheck
      satSchedFOH
      satSchedBOH
      sunProjSales
      sunProjAvgCheck
      sunSchedFOH
      sunSchedBOH
      __typename
    }
  }
`;
export const getR0003Reportv2 = /* GraphQL */ `
  query GetR0003Reportv2($week: String!, $user: String!, $role: String!) {
    getR0003Reportv2(week: $week, user: $user, role: $role) {
      id
      data {
        area
        data {
          day
          projCheckCount
          projAvgCheck
          projSales
          theoFOH
          theoBOH
          projSPLH
          schedFOH
          schedBOH
          schedSPLH
          actCheckCount
          actAvgCheck
          actSales
          adjTheoFOH
          adjTheoBOH
          actFOH
          actBOH
          fohActVsTheo
          bohActVsTheo
          theoSPLH
          actSPLH
          trainingFOH
          trainingBOH
          notes
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getReport = /* GraphQL */ `
  query GetReport(
    $userName: String!
    $clientId: String!
    $reportId: String!
    $reportVariables: [ReportVariable]
  ) {
    getReport(
      userName: $userName
      clientId: $clientId
      reportId: $reportId
      reportVariables: $reportVariables
    ) {
      pageId
      data {
        rowNum
        rowType
        rowCells {
          colName
          value
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getReportv2 = /* GraphQL */ `
  query GetReportv2(
    $userName: String!
    $clientId: String!
    $reportId: String!
    $reportVariables: AWSJSON
  ) {
    getReportv2(
      userName: $userName
      clientId: $clientId
      reportId: $reportId
      reportVariables: $reportVariables
    ) {
      statusState
      statusMessage
      statusItem
      __typename
    }
  }
`;
export const listAreas2 = /* GraphQL */ `
  query ListAreas2($report: String!, $user: String, $role: String) {
    listAreas2(report: $report, user: $user, role: $role) {
      areaId
      areaName
      areaManager
      areaType
      stores {
        storeId
        shortName
        longName
        fohBaseTheoHrs {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        bohBaseTheoHrs {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        gm
        status
        type
        compStores {
          storeId
          shortName
          __typename
        }
        thresholds {
          avgCheck
          netSales
          splhTotal
          splhFOH
          splhBOH
          __typename
        }
        toastId
        __typename
      }
      __typename
    }
  }
`;
export const listAreas3 = /* GraphQL */ `
  query ListAreas3($report: String!, $user: String, $role: String) {
    listAreas3(report: $report, user: $user, role: $role) {
      areaId
      areaName
      areaManager
      areaType
      stores {
        storeId
        shortName
        longName
        fohBaseTheoHrs {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        bohBaseTheoHrs {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        gm
        status
        type
        compStores {
          storeId
          shortName
          __typename
        }
        thresholds {
          avgCheck
          netSales
          splhTotal
          splhFOH
          splhBOH
          __typename
        }
        toastId
        __typename
      }
      __typename
    }
  }
`;
export const listMessages = /* GraphQL */ `
  query ListMessages($clientId: String!, $status: String) {
    listMessages(clientId: $clientId, status: $status) {
      messageId
      note
      status
      position
      createdAt
      __typename
    }
  }
`;
export const listMetrics = /* GraphQL */ `
  query ListMetrics(
    $clientId: ID!
    $startDate: AWSDate!
    $endDate: AWSDate!
    $storeIds: [String!]
    $metricNames: [String!]
    $frequencies: [FrequencyType!]
  ) {
    listMetrics(
      clientId: $clientId
      startDate: $startDate
      endDate: $endDate
      storeIds: $storeIds
      metricNames: $metricNames
      frequencies: $frequencies
    ) {
      items {
        metricId
        clientId
        storeId
        date
        hour
        frequency
        metricName
        metricType
        numberValue
        stringValue
        booleanValue
        dayPart
        diningOption
        source
        timestamp
        unit
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRoles = /* GraphQL */ `
  query ListRoles($clientId: String!) {
    listRoles(clientId: $clientId) {
      clientId
      role
      description
      __typename
    }
  }
`;
export const listUserPermissions = /* GraphQL */ `
  query ListUserPermissions($role: String!) {
    listUserPermissions(role: $role) {
      report
      viewPermissions
      updatePermissions
      __typename
    }
  }
`;
export const permValidateGrant = /* GraphQL */ `
  query PermValidateGrant($grant: CreateGrantInput!) {
    permValidateGrant(grant: $grant) {
      isValid
      errors {
        field
        code
        message
        suggestion
        __typename
      }
      warnings {
        field
        code
        message
        suggestion
        __typename
      }
      summary {
        hasErrors
        hasWarnings
        errorCount
        warningCount
        categories
        __typename
      }
      canProceed
      requiresConfirmation
      __typename
    }
  }
`;
export const permCheckPermission = /* GraphQL */ `
  query PermCheckPermission(
    $userId: ID!
    $resource: String!
    $action: String!
    $constraints: AWSJSON
    $checkSecurityVersion: Boolean
    $includeDataScope: Boolean
  ) {
    permCheckPermission(
      userId: $userId
      resource: $resource
      action: $action
      constraints: $constraints
      checkSecurityVersion: $checkSecurityVersion
      includeDataScope: $includeDataScope
    ) {
      allowed
      reason
      message
      permission
      dataScope
      grantId
      grantType
      requiresRecalculation
      failedConstraints
      __typename
    }
  }
`;
export const permGetApplicableGrants = /* GraphQL */ `
  query PermGetApplicableGrants(
    $userId: ID!
    $clientId: String!
    $includeInactive: Boolean
    $includeExpired: Boolean
    $resourceFilter: String
  ) {
    permGetApplicableGrants(
      userId: $userId
      clientId: $clientId
      includeInactive: $includeInactive
      includeExpired: $includeExpired
      resourceFilter: $resourceFilter
    ) {
      success
      userId
      userInfo
      grants
      summary
      debugInfo
      error
      __typename
    }
  }
`;
export const invokePermMutationWrappers = /* GraphQL */ `
  query InvokePermMutationWrappers(
    $operation: String!
    $grant: AWSJSON
    $grantId: String
    $clientId: String!
  ) {
    invokePermMutationWrappers(
      operation: $operation
      grant: $grant
      grantId: $grantId
      clientId: $clientId
    )
  }
`;
export const getSPLHDashboardData = /* GraphQL */ `
  query GetSPLHDashboardData($input: SPLHDashboardInput!) {
    getSPLHDashboardData(input: $input) {
      kpis {
        splhTotal
        splhFOH
        splhBOH
        totalSales
        fohHours
        bohHours
        trend
        __typename
      }
      trendData {
        date
        splh
        laborHours
        sales
        __typename
      }
      hierarchyData {
        id
        name
        level
        parentId
        splh
        trend
        laborHours
        fohHours
        bohHours
        laborPercent
        sales
        targetDelta
        hasChildren
        children {
          id
          name
          level
          parentId
          splh
          trend
          laborHours
          fohHours
          bohHours
          laborPercent
          sales
          targetDelta
          hasChildren
          children {
            id
            name
            level
            parentId
            splh
            trend
            laborHours
            fohHours
            bohHours
            laborPercent
            sales
            targetDelta
            hasChildren
            children {
              id
              name
              level
              parentId
              splh
              trend
              laborHours
              fohHours
              bohHours
              laborPercent
              sales
              targetDelta
              hasChildren
              children {
                id
                name
                level
                parentId
                splh
                trend
                laborHours
                fohHours
                bohHours
                laborPercent
                sales
                targetDelta
                hasChildren
                children {
                  id
                  name
                  level
                  parentId
                  splh
                  trend
                  laborHours
                  fohHours
                  bohHours
                  laborPercent
                  sales
                  targetDelta
                  hasChildren
                  children {
                    id
                    name
                    level
                    parentId
                    splh
                    trend
                    laborHours
                    fohHours
                    bohHours
                    laborPercent
                    sales
                    targetDelta
                    hasChildren
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      breakdownData {
        topPerformers {
          key
          label
          splh
          laborHours
          sales
          percentage
          meetsThreshold
          __typename
        }
        bottomPerformers {
          key
          label
          splh
          laborHours
          sales
          percentage
          meetsThreshold
          __typename
        }
        byDayOfWeek {
          key
          label
          splh
          laborHours
          sales
          percentage
          __typename
        }
        byDaypart {
          key
          label
          splh
          laborHours
          sales
          percentage
          __typename
        }
        __typename
      }
      alerts {
        id
        severity
        message
        nodeId
        nodeName
        nodeLevel
        timestamp
        __typename
      }
      hierarchyMetadata {
        levels {
          level
          displayName
          order
          isUsed
          __typename
        }
        clientName
        __typename
      }
      __typename
    }
  }
`;
export const getSPLHDashboardDataV2 = /* GraphQL */ `
  query GetSPLHDashboardDataV2($input: SPLHDashboardInputV2!) {
    getSPLHDashboardDataV2(input: $input) {
      comparisonMode
      currentRange {
        startDate
        endDate
        __typename
      }
      comparisonRange {
        startDate
        endDate
        __typename
      }
      kpis {
        metricName
        value {
          current
          comparison
          delta
          deltaPct
          direction
          __typename
        }
        subMetrics {
          foh
          boh
          fohComparison
          bohComparison
          __typename
        }
        __typename
      }
      trendData {
        date
        currentSPLH
        comparisonSPLH
        deltaPct
        currentSales
        comparisonSales
        currentHours
        comparisonHours
        __typename
      }
      hierarchyData {
        id
        name
        level
        parentId
        splh {
          current
          comparison
          delta
          deltaPct
          direction
          __typename
        }
        sales {
          current
          comparison
          delta
          deltaPct
          direction
          __typename
        }
        laborHours {
          current
          comparison
          delta
          deltaPct
          direction
          __typename
        }
        laborDollars {
          current
          comparison
          delta
          deltaPct
          direction
          __typename
        }
        laborPct {
          current
          comparison
          delta
          deltaPct
          direction
          __typename
        }
        checkCount {
          current
          comparison
          delta
          deltaPct
          direction
          __typename
        }
        fohHours
        bohHours
        fohSPLH
        bohSPLH
        hasChildren
        children {
          id
          name
          level
          parentId
          splh {
            current
            comparison
            delta
            deltaPct
            direction
            __typename
          }
          sales {
            current
            comparison
            delta
            deltaPct
            direction
            __typename
          }
          laborHours {
            current
            comparison
            delta
            deltaPct
            direction
            __typename
          }
          laborDollars {
            current
            comparison
            delta
            deltaPct
            direction
            __typename
          }
          laborPct {
            current
            comparison
            delta
            deltaPct
            direction
            __typename
          }
          checkCount {
            current
            comparison
            delta
            deltaPct
            direction
            __typename
          }
          fohHours
          bohHours
          fohSPLH
          bohSPLH
          hasChildren
          children {
            id
            name
            level
            parentId
            splh {
              current
              comparison
              delta
              deltaPct
              direction
              __typename
            }
            sales {
              current
              comparison
              delta
              deltaPct
              direction
              __typename
            }
            laborHours {
              current
              comparison
              delta
              deltaPct
              direction
              __typename
            }
            laborDollars {
              current
              comparison
              delta
              deltaPct
              direction
              __typename
            }
            laborPct {
              current
              comparison
              delta
              deltaPct
              direction
              __typename
            }
            checkCount {
              current
              comparison
              delta
              deltaPct
              direction
              __typename
            }
            fohHours
            bohHours
            fohSPLH
            bohSPLH
            hasChildren
            children {
              id
              name
              level
              parentId
              splh {
                current
                comparison
                delta
                deltaPct
                direction
                __typename
              }
              sales {
                current
                comparison
                delta
                deltaPct
                direction
                __typename
              }
              laborHours {
                current
                comparison
                delta
                deltaPct
                direction
                __typename
              }
              laborDollars {
                current
                comparison
                delta
                deltaPct
                direction
                __typename
              }
              laborPct {
                current
                comparison
                delta
                deltaPct
                direction
                __typename
              }
              checkCount {
                current
                comparison
                delta
                deltaPct
                direction
                __typename
              }
              fohHours
              bohHours
              fohSPLH
              bohSPLH
              hasChildren
              children {
                id
                name
                level
                parentId
                splh {
                  current
                  comparison
                  delta
                  deltaPct
                  direction
                  __typename
                }
                sales {
                  current
                  comparison
                  delta
                  deltaPct
                  direction
                  __typename
                }
                laborHours {
                  current
                  comparison
                  delta
                  deltaPct
                  direction
                  __typename
                }
                laborDollars {
                  current
                  comparison
                  delta
                  deltaPct
                  direction
                  __typename
                }
                laborPct {
                  current
                  comparison
                  delta
                  deltaPct
                  direction
                  __typename
                }
                checkCount {
                  current
                  comparison
                  delta
                  deltaPct
                  direction
                  __typename
                }
                fohHours
                bohHours
                fohSPLH
                bohSPLH
                hasChildren
                children {
                  id
                  name
                  level
                  parentId
                  splh {
                    current
                    comparison
                    delta
                    deltaPct
                    direction
                    __typename
                  }
                  sales {
                    current
                    comparison
                    delta
                    deltaPct
                    direction
                    __typename
                  }
                  laborHours {
                    current
                    comparison
                    delta
                    deltaPct
                    direction
                    __typename
                  }
                  laborDollars {
                    current
                    comparison
                    delta
                    deltaPct
                    direction
                    __typename
                  }
                  laborPct {
                    current
                    comparison
                    delta
                    deltaPct
                    direction
                    __typename
                  }
                  checkCount {
                    current
                    comparison
                    delta
                    deltaPct
                    direction
                    __typename
                  }
                  fohHours
                  bohHours
                  fohSPLH
                  bohSPLH
                  hasChildren
                  children {
                    id
                    name
                    level
                    parentId
                    fohHours
                    bohHours
                    fohSPLH
                    bohSPLH
                    hasChildren
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      breakdownData {
        topPerformers {
          locationId
          locationName
          orgLevel_1_Id
          orgLevel_1_Name
          orgLevel_2_Id
          orgLevel_2_Name
          orgLevel_3_Id
          orgLevel_3_Name
          splhCurrent
          splhComparison
          splhDeltaPct
          salesCurrent
          salesComparison
          salesDeltaPct
          checkCountCurrent
          checkCountComparison
          checkCountDeltaPct
          hoursCurrent
          hoursComparison
          hoursDeltaPct
          laborDollarsCurrent
          laborDollarsComparison
          laborDollarsDeltaPct
          laborPctCurrent
          laborPctComparison
          laborPctDeltaPct
          eligible
          exclusionReason
          __typename
        }
        bottomPerformers {
          locationId
          locationName
          orgLevel_1_Id
          orgLevel_1_Name
          orgLevel_2_Id
          orgLevel_2_Name
          orgLevel_3_Id
          orgLevel_3_Name
          splhCurrent
          splhComparison
          splhDeltaPct
          salesCurrent
          salesComparison
          salesDeltaPct
          checkCountCurrent
          checkCountComparison
          checkCountDeltaPct
          hoursCurrent
          hoursComparison
          hoursDeltaPct
          laborDollarsCurrent
          laborDollarsComparison
          laborDollarsDeltaPct
          laborPctCurrent
          laborPctComparison
          laborPctDeltaPct
          eligible
          exclusionReason
          __typename
        }
        byDayOfWeek {
          key
          label
          currentSPLH
          comparisonSPLH
          deltaPct
          currentSales
          comparisonSales
          currentHours
          comparisonHours
          __typename
        }
        byDaypart {
          key
          label
          currentSPLH
          comparisonSPLH
          deltaPct
          currentSales
          comparisonSales
          currentHours
          comparisonHours
          __typename
        }
        excludedCount
        __typename
      }
      alerts {
        splh {
          critical {
            id
            metric
            severity
            scopeLevel
            entityId
            entityName
            parentEntityId
            parentEntityName
            parentLevel
            message
            currentValue
            comparisonValue
            delta
            deltaPct
            __typename
          }
          warning {
            id
            metric
            severity
            scopeLevel
            entityId
            entityName
            parentEntityId
            parentEntityName
            parentLevel
            message
            currentValue
            comparisonValue
            delta
            deltaPct
            __typename
          }
          __typename
        }
        sales {
          critical {
            id
            metric
            severity
            scopeLevel
            entityId
            entityName
            parentEntityId
            parentEntityName
            parentLevel
            message
            currentValue
            comparisonValue
            delta
            deltaPct
            __typename
          }
          warning {
            id
            metric
            severity
            scopeLevel
            entityId
            entityName
            parentEntityId
            parentEntityName
            parentLevel
            message
            currentValue
            comparisonValue
            delta
            deltaPct
            __typename
          }
          __typename
        }
        laborPct {
          critical {
            id
            metric
            severity
            scopeLevel
            entityId
            entityName
            parentEntityId
            parentEntityName
            parentLevel
            message
            currentValue
            comparisonValue
            delta
            deltaPct
            __typename
          }
          warning {
            id
            metric
            severity
            scopeLevel
            entityId
            entityName
            parentEntityId
            parentEntityName
            parentLevel
            message
            currentValue
            comparisonValue
            delta
            deltaPct
            __typename
          }
          __typename
        }
        hours {
          critical {
            id
            metric
            severity
            scopeLevel
            entityId
            entityName
            parentEntityId
            parentEntityName
            parentLevel
            message
            currentValue
            comparisonValue
            delta
            deltaPct
            __typename
          }
          warning {
            id
            metric
            severity
            scopeLevel
            entityId
            entityName
            parentEntityId
            parentEntityName
            parentLevel
            message
            currentValue
            comparisonValue
            delta
            deltaPct
            __typename
          }
          __typename
        }
        __typename
      }
      hierarchyMetadata {
        levels {
          levelId
          label
          order
          isUsed
          introducedInVersion
          __typename
        }
        clientName
        __typename
      }
      aiInput {
        clientId
        comparisonMode
        currentRange {
          startDate
          endDate
          __typename
        }
        comparisonRange {
          startDate
          endDate
          __typename
        }
        kpiSummary
        alertsSummary
        topPerformers
        bottomPerformers
        __typename
      }
      __typename
    }
  }
`;
export const generateSplhAiInsights = /* GraphQL */ `
  query GenerateSplhAiInsights($input: SPLHAIInput!) {
    generateSplhAiInsights(input: $input) {
      summary
      available
      errorMessage
      generatedAt
      __typename
    }
  }
`;
export const getClient = /* GraphQL */ `
  query GetClient($id: ID!) {
    getClient(id: $id) {
      id
      clientId
      clientName
      contactName
      contactPhone
      contactEmail
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listClients = /* GraphQL */ `
  query ListClients(
    $filter: ModelClientFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listClients(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        clientId
        clientName
        contactName
        contactPhone
        contactEmail
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getForecastedSales = /* GraphQL */ `
  query GetForecastedSales($id: ID!) {
    getForecastedSales(id: $id) {
      id
      storeName
      date
      forecastedSales
      storeId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listForecastedSales = /* GraphQL */ `
  query ListForecastedSales(
    $filter: ModelForecastedSalesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listForecastedSales(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        storeName
        date
        forecastedSales
        storeId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getHierarchyDefinition = /* GraphQL */ `
  query GetHierarchyDefinition($id: ID!) {
    getHierarchyDefinition(id: $id) {
      id
      clientId
      version
      effectiveDate
      endDate
      levels {
        levelId
        label
        order
        isUsed
        introducedInVersion
        __typename
      }
      changeReason
      changedBy
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const listHierarchyDefinitions = /* GraphQL */ `
  query ListHierarchyDefinitions(
    $filter: ModelHierarchyDefinitionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHierarchyDefinitions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        version
        effectiveDate
        endDate
        levels {
          levelId
          label
          order
          isUsed
          introducedInVersion
          __typename
        }
        changeReason
        changedBy
        createdAt
        lastModified
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const hierarchyDefinitionsByClient = /* GraphQL */ `
  query HierarchyDefinitionsByClient(
    $clientId: String!
    $version: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelHierarchyDefinitionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    hierarchyDefinitionsByClient(
      clientId: $clientId
      version: $version
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        version
        effectiveDate
        endDate
        levels {
          levelId
          label
          order
          isUsed
          introducedInVersion
          __typename
        }
        changeReason
        changedBy
        createdAt
        lastModified
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrgUnit = /* GraphQL */ `
  query GetOrgUnit($id: ID!) {
    getOrgUnit(id: $id) {
      id
      clientId
      orgLevel
      name
      isActive
      sortOrder
      parentOrgUnitId
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOrgUnits = /* GraphQL */ `
  query ListOrgUnits(
    $filter: ModelOrgUnitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrgUnits(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        clientId
        orgLevel
        name
        isActive
        sortOrder
        parentOrgUnitId
        metadata
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const orgUnitsByClientAndLevel = /* GraphQL */ `
  query OrgUnitsByClientAndLevel(
    $clientId: String!
    $orgLevel: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrgUnitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    orgUnitsByClientAndLevel(
      clientId: $clientId
      orgLevel: $orgLevel
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        orgLevel
        name
        isActive
        sortOrder
        parentOrgUnitId
        metadata
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStoreRecord = /* GraphQL */ `
  query GetStoreRecord($id: ID!) {
    getStoreRecord(id: $id) {
      id
      clientId
      storeId
      storeName
      storeNumber
      externalSystems {
        systemType
        systemId
        systemName
        isActive
        isPrimaryPOS
        lastSyncAt
        syncStatus
        metadata
        __typename
      }
      toastId
      timeZone
      address {
        street_1
        street_2
        city
        state
        zipCode
        country
        __typename
      }
      openDate
      closeDate
      orgLevel_1
      orgLevel_2
      orgLevel_3
      managerUserIds
      ownershipType
      conceptId
      tags
      fohBaseTheoHrs {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohBaseTheoHrs {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      metadata
      lastHierarchyChange
      lastHierarchyChangeBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listStoreRecords = /* GraphQL */ `
  query ListStoreRecords(
    $filter: ModelStoreRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStoreRecords(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        clientId
        storeId
        storeName
        storeNumber
        externalSystems {
          systemType
          systemId
          systemName
          isActive
          isPrimaryPOS
          lastSyncAt
          syncStatus
          metadata
          __typename
        }
        toastId
        timeZone
        address {
          street_1
          street_2
          city
          state
          zipCode
          country
          __typename
        }
        openDate
        closeDate
        orgLevel_1
        orgLevel_2
        orgLevel_3
        managerUserIds
        ownershipType
        conceptId
        tags
        fohBaseTheoHrs {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        bohBaseTheoHrs {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        metadata
        lastHierarchyChange
        lastHierarchyChangeBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const storeByClientId = /* GraphQL */ `
  query StoreByClientId(
    $clientId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelStoreRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    storeByClientId(
      clientId: $clientId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        storeId
        storeName
        storeNumber
        externalSystems {
          systemType
          systemId
          systemName
          isActive
          isPrimaryPOS
          lastSyncAt
          syncStatus
          metadata
          __typename
        }
        toastId
        timeZone
        address {
          street_1
          street_2
          city
          state
          zipCode
          country
          __typename
        }
        openDate
        closeDate
        orgLevel_1
        orgLevel_2
        orgLevel_3
        managerUserIds
        ownershipType
        conceptId
        tags
        fohBaseTheoHrs {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        bohBaseTheoHrs {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        metadata
        lastHierarchyChange
        lastHierarchyChangeBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const storesByClientSorted = /* GraphQL */ `
  query StoresByClientSorted(
    $clientId: String!
    $storeName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStoreRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    storesByClientSorted(
      clientId: $clientId
      storeName: $storeName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        storeId
        storeName
        storeNumber
        externalSystems {
          systemType
          systemId
          systemName
          isActive
          isPrimaryPOS
          lastSyncAt
          syncStatus
          metadata
          __typename
        }
        toastId
        timeZone
        address {
          street_1
          street_2
          city
          state
          zipCode
          country
          __typename
        }
        openDate
        closeDate
        orgLevel_1
        orgLevel_2
        orgLevel_3
        managerUserIds
        ownershipType
        conceptId
        tags
        fohBaseTheoHrs {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        bohBaseTheoHrs {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        metadata
        lastHierarchyChange
        lastHierarchyChangeBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const storeByOrgLevel_1 = /* GraphQL */ `
  query StoreByOrgLevel_1(
    $orgLevel_1: String!
    $sortDirection: ModelSortDirection
    $filter: ModelStoreRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    storeByOrgLevel_1(
      orgLevel_1: $orgLevel_1
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        storeId
        storeName
        storeNumber
        externalSystems {
          systemType
          systemId
          systemName
          isActive
          isPrimaryPOS
          lastSyncAt
          syncStatus
          metadata
          __typename
        }
        toastId
        timeZone
        address {
          street_1
          street_2
          city
          state
          zipCode
          country
          __typename
        }
        openDate
        closeDate
        orgLevel_1
        orgLevel_2
        orgLevel_3
        managerUserIds
        ownershipType
        conceptId
        tags
        fohBaseTheoHrs {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        bohBaseTheoHrs {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        metadata
        lastHierarchyChange
        lastHierarchyChangeBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const storeByOrgLevel_2 = /* GraphQL */ `
  query StoreByOrgLevel_2(
    $orgLevel_2: String!
    $sortDirection: ModelSortDirection
    $filter: ModelStoreRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    storeByOrgLevel_2(
      orgLevel_2: $orgLevel_2
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        storeId
        storeName
        storeNumber
        externalSystems {
          systemType
          systemId
          systemName
          isActive
          isPrimaryPOS
          lastSyncAt
          syncStatus
          metadata
          __typename
        }
        toastId
        timeZone
        address {
          street_1
          street_2
          city
          state
          zipCode
          country
          __typename
        }
        openDate
        closeDate
        orgLevel_1
        orgLevel_2
        orgLevel_3
        managerUserIds
        ownershipType
        conceptId
        tags
        fohBaseTheoHrs {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        bohBaseTheoHrs {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        metadata
        lastHierarchyChange
        lastHierarchyChangeBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const storeByOrgLevel_3 = /* GraphQL */ `
  query StoreByOrgLevel_3(
    $orgLevel_3: String!
    $sortDirection: ModelSortDirection
    $filter: ModelStoreRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    storeByOrgLevel_3(
      orgLevel_3: $orgLevel_3
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        storeId
        storeName
        storeNumber
        externalSystems {
          systemType
          systemId
          systemName
          isActive
          isPrimaryPOS
          lastSyncAt
          syncStatus
          metadata
          __typename
        }
        toastId
        timeZone
        address {
          street_1
          street_2
          city
          state
          zipCode
          country
          __typename
        }
        openDate
        closeDate
        orgLevel_1
        orgLevel_2
        orgLevel_3
        managerUserIds
        ownershipType
        conceptId
        tags
        fohBaseTheoHrs {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        bohBaseTheoHrs {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        metadata
        lastHierarchyChange
        lastHierarchyChangeBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLocation = /* GraphQL */ `
  query GetLocation($id: ID!) {
    getLocation(id: $id) {
      id
      clientId
      locationName
      locationNumber
      externalSystems {
        systemType
        systemId
        systemName
        isActive
        isPrimaryPOS
        lastSyncAt
        syncStatus
        metadata
        __typename
      }
      timeZone
      address {
        street_1
        street_2
        city
        state
        zipCode
        country
        __typename
      }
      openDate
      closeDate
      orgLevel_1
      orgLevel_2
      orgLevel_3
      ownershipType
      conceptId
      metadata
      lastHierarchyChange
      lastHierarchyChangeBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listLocations = /* GraphQL */ `
  query ListLocations(
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        clientId
        locationName
        locationNumber
        externalSystems {
          systemType
          systemId
          systemName
          isActive
          isPrimaryPOS
          lastSyncAt
          syncStatus
          metadata
          __typename
        }
        timeZone
        address {
          street_1
          street_2
          city
          state
          zipCode
          country
          __typename
        }
        openDate
        closeDate
        orgLevel_1
        orgLevel_2
        orgLevel_3
        ownershipType
        conceptId
        metadata
        lastHierarchyChange
        lastHierarchyChangeBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const locationByClientId = /* GraphQL */ `
  query LocationByClientId(
    $clientId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationByClientId(
      clientId: $clientId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        locationName
        locationNumber
        externalSystems {
          systemType
          systemId
          systemName
          isActive
          isPrimaryPOS
          lastSyncAt
          syncStatus
          metadata
          __typename
        }
        timeZone
        address {
          street_1
          street_2
          city
          state
          zipCode
          country
          __typename
        }
        openDate
        closeDate
        orgLevel_1
        orgLevel_2
        orgLevel_3
        ownershipType
        conceptId
        metadata
        lastHierarchyChange
        lastHierarchyChangeBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const locationsByClientSorted = /* GraphQL */ `
  query LocationsByClientSorted(
    $clientId: String!
    $locationName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationsByClientSorted(
      clientId: $clientId
      locationName: $locationName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        locationName
        locationNumber
        externalSystems {
          systemType
          systemId
          systemName
          isActive
          isPrimaryPOS
          lastSyncAt
          syncStatus
          metadata
          __typename
        }
        timeZone
        address {
          street_1
          street_2
          city
          state
          zipCode
          country
          __typename
        }
        openDate
        closeDate
        orgLevel_1
        orgLevel_2
        orgLevel_3
        ownershipType
        conceptId
        metadata
        lastHierarchyChange
        lastHierarchyChangeBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const locationByOrgLevel_1 = /* GraphQL */ `
  query LocationByOrgLevel_1(
    $orgLevel_1: String!
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationByOrgLevel_1(
      orgLevel_1: $orgLevel_1
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        locationName
        locationNumber
        externalSystems {
          systemType
          systemId
          systemName
          isActive
          isPrimaryPOS
          lastSyncAt
          syncStatus
          metadata
          __typename
        }
        timeZone
        address {
          street_1
          street_2
          city
          state
          zipCode
          country
          __typename
        }
        openDate
        closeDate
        orgLevel_1
        orgLevel_2
        orgLevel_3
        ownershipType
        conceptId
        metadata
        lastHierarchyChange
        lastHierarchyChangeBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const locationByOrgLevel_2 = /* GraphQL */ `
  query LocationByOrgLevel_2(
    $orgLevel_2: String!
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationByOrgLevel_2(
      orgLevel_2: $orgLevel_2
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        locationName
        locationNumber
        externalSystems {
          systemType
          systemId
          systemName
          isActive
          isPrimaryPOS
          lastSyncAt
          syncStatus
          metadata
          __typename
        }
        timeZone
        address {
          street_1
          street_2
          city
          state
          zipCode
          country
          __typename
        }
        openDate
        closeDate
        orgLevel_1
        orgLevel_2
        orgLevel_3
        ownershipType
        conceptId
        metadata
        lastHierarchyChange
        lastHierarchyChangeBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const locationByOrgLevel_3 = /* GraphQL */ `
  query LocationByOrgLevel_3(
    $orgLevel_3: String!
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationByOrgLevel_3(
      orgLevel_3: $orgLevel_3
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        locationName
        locationNumber
        externalSystems {
          systemType
          systemId
          systemName
          isActive
          isPrimaryPOS
          lastSyncAt
          syncStatus
          metadata
          __typename
        }
        timeZone
        address {
          street_1
          street_2
          city
          state
          zipCode
          country
          __typename
        }
        openDate
        closeDate
        orgLevel_1
        orgLevel_2
        orgLevel_3
        ownershipType
        conceptId
        metadata
        lastHierarchyChange
        lastHierarchyChangeBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLocationLaborTargets = /* GraphQL */ `
  query GetLocationLaborTargets($id: ID!) {
    getLocationLaborTargets(id: $id) {
      id
      clientId
      locationId
      fohBaseHours {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohBaseHours {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      fohSplhTargets {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      bohSplhTargets {
        Mon
        Tue
        Wed
        Thu
        Fri
        Sat
        Sun
        __typename
      }
      effectiveDate
      endDate
      isActive
      reason
      reasonType
      supersedes
      supersededBy
      changedBy
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const listLocationLaborTargets = /* GraphQL */ `
  query ListLocationLaborTargets(
    $filter: ModelLocationLaborTargetsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationLaborTargets(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        locationId
        fohBaseHours {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        bohBaseHours {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        fohSplhTargets {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        bohSplhTargets {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        effectiveDate
        endDate
        isActive
        reason
        reasonType
        supersedes
        supersededBy
        changedBy
        createdAt
        lastModified
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const locationLaborTargetsByClientLocation = /* GraphQL */ `
  query LocationLaborTargetsByClientLocation(
    $clientId: String!
    $locationIdEffectiveDate: ModelLocationLaborTargetsByClientLocationCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationLaborTargetsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationLaborTargetsByClientLocation(
      clientId: $clientId
      locationIdEffectiveDate: $locationIdEffectiveDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        locationId
        fohBaseHours {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        bohBaseHours {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        fohSplhTargets {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        bohSplhTargets {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        effectiveDate
        endDate
        isActive
        reason
        reasonType
        supersedes
        supersededBy
        changedBy
        createdAt
        lastModified
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const locationLaborTargetsByDate = /* GraphQL */ `
  query LocationLaborTargetsByDate(
    $locationId: ID!
    $effectiveDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationLaborTargetsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationLaborTargetsByDate(
      locationId: $locationId
      effectiveDate: $effectiveDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        locationId
        fohBaseHours {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        bohBaseHours {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        fohSplhTargets {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        bohSplhTargets {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        effectiveDate
        endDate
        isActive
        reason
        reasonType
        supersedes
        supersededBy
        changedBy
        createdAt
        lastModified
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const locationLaborTargetsByClientUpdater = /* GraphQL */ `
  query LocationLaborTargetsByClientUpdater(
    $changedBy: ID!
    $clientIdEffectiveDate: ModelLocationLaborTargetsByClientUpdaterCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationLaborTargetsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationLaborTargetsByClientUpdater(
      changedBy: $changedBy
      clientIdEffectiveDate: $clientIdEffectiveDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        locationId
        fohBaseHours {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        bohBaseHours {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        fohSplhTargets {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        bohSplhTargets {
          Mon
          Tue
          Wed
          Thu
          Fri
          Sat
          Sun
          __typename
        }
        effectiveDate
        endDate
        isActive
        reason
        reasonType
        supersedes
        supersededBy
        changedBy
        createdAt
        lastModified
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRoleDefinition = /* GraphQL */ `
  query GetRoleDefinition($id: ID!) {
    getRoleDefinition(id: $id) {
      id
      clientId
      roleName
      roleCode
      assignmentLevel
      category
      sortOrder
      isActive
      isDefault
      metadata
      createdBy
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const listRoleDefinitions = /* GraphQL */ `
  query ListRoleDefinitions(
    $filter: ModelRoleDefinitionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRoleDefinitions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        clientId
        roleName
        roleCode
        assignmentLevel
        category
        sortOrder
        isActive
        isDefault
        metadata
        createdBy
        createdAt
        lastModified
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const roleDefinitionsByClient = /* GraphQL */ `
  query RoleDefinitionsByClient(
    $clientId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelRoleDefinitionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    roleDefinitionsByClient(
      clientId: $clientId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        roleName
        roleCode
        assignmentLevel
        category
        sortOrder
        isActive
        isDefault
        metadata
        createdBy
        createdAt
        lastModified
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEmployee = /* GraphQL */ `
  query GetEmployee($id: ID!) {
    getEmployee(id: $id) {
      id
      clientId
      firstName
      lastName
      email
      phoneNumber
      externalSystems {
        systemType
        systemId
        systemName
        isActive
        isPrimaryPOS
        lastSyncAt
        syncStatus
        metadata
        __typename
      }
      isActive
      employmentType
      hireDate
      terminationDate
      userId
      tags
      metadata
      createdAt
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const listEmployees = /* GraphQL */ `
  query ListEmployees(
    $filter: ModelEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployees(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        clientId
        firstName
        lastName
        email
        phoneNumber
        externalSystems {
          systemType
          systemId
          systemName
          isActive
          isPrimaryPOS
          lastSyncAt
          syncStatus
          metadata
          __typename
        }
        isActive
        employmentType
        hireDate
        terminationDate
        userId
        tags
        metadata
        createdAt
        lastModified
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeesByClient = /* GraphQL */ `
  query EmployeesByClient(
    $clientId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeesByClient(
      clientId: $clientId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        firstName
        lastName
        email
        phoneNumber
        externalSystems {
          systemType
          systemId
          systemName
          isActive
          isPrimaryPOS
          lastSyncAt
          syncStatus
          metadata
          __typename
        }
        isActive
        employmentType
        hireDate
        terminationDate
        userId
        tags
        metadata
        createdAt
        lastModified
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeeByEmail = /* GraphQL */ `
  query EmployeeByEmail(
    $email: String!
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeeByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        firstName
        lastName
        email
        phoneNumber
        externalSystems {
          systemType
          systemId
          systemName
          isActive
          isPrimaryPOS
          lastSyncAt
          syncStatus
          metadata
          __typename
        }
        isActive
        employmentType
        hireDate
        terminationDate
        userId
        tags
        metadata
        createdAt
        lastModified
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeeByUser = /* GraphQL */ `
  query EmployeeByUser(
    $userId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeeByUser(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        firstName
        lastName
        email
        phoneNumber
        externalSystems {
          systemType
          systemId
          systemName
          isActive
          isPrimaryPOS
          lastSyncAt
          syncStatus
          metadata
          __typename
        }
        isActive
        employmentType
        hireDate
        terminationDate
        userId
        tags
        metadata
        createdAt
        lastModified
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLocationEmployee = /* GraphQL */ `
  query GetLocationEmployee($id: ID!) {
    getLocationEmployee(id: $id) {
      id
      clientId
      employeeId
      locationId
      roleDefinitionId
      isPrimary
      isActive
      effectiveDate
      endDate
      assignedBy
      assignmentReason
      changeReason
      employeeNameSnapshot
      locationNameSnapshot
      roleSnapshot
      createdAt
      lastModified
      changedBy
      updatedAt
      __typename
    }
  }
`;
export const listLocationEmployees = /* GraphQL */ `
  query ListLocationEmployees(
    $filter: ModelLocationEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationEmployees(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        employeeId
        locationId
        roleDefinitionId
        isPrimary
        isActive
        effectiveDate
        endDate
        assignedBy
        assignmentReason
        changeReason
        employeeNameSnapshot
        locationNameSnapshot
        roleSnapshot
        createdAt
        lastModified
        changedBy
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const locationEmployeesByClient = /* GraphQL */ `
  query LocationEmployeesByClient(
    $clientId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelLocationEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationEmployeesByClient(
      clientId: $clientId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        employeeId
        locationId
        roleDefinitionId
        isPrimary
        isActive
        effectiveDate
        endDate
        assignedBy
        assignmentReason
        changeReason
        employeeNameSnapshot
        locationNameSnapshot
        roleSnapshot
        createdAt
        lastModified
        changedBy
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const locationAssignmentsByEmployee = /* GraphQL */ `
  query LocationAssignmentsByEmployee(
    $employeeId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLocationEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationAssignmentsByEmployee(
      employeeId: $employeeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        employeeId
        locationId
        roleDefinitionId
        isPrimary
        isActive
        effectiveDate
        endDate
        assignedBy
        assignmentReason
        changeReason
        employeeNameSnapshot
        locationNameSnapshot
        roleSnapshot
        createdAt
        lastModified
        changedBy
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const locationEmployeesByLocation = /* GraphQL */ `
  query LocationEmployeesByLocation(
    $locationId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLocationEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationEmployeesByLocation(
      locationId: $locationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        employeeId
        locationId
        roleDefinitionId
        isPrimary
        isActive
        effectiveDate
        endDate
        assignedBy
        assignmentReason
        changeReason
        employeeNameSnapshot
        locationNameSnapshot
        roleSnapshot
        createdAt
        lastModified
        changedBy
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrgUnitEmployee = /* GraphQL */ `
  query GetOrgUnitEmployee($id: ID!) {
    getOrgUnitEmployee(id: $id) {
      id
      clientId
      employeeId
      orgUnitId
      managementLevel
      roleDefinitionId
      isActive
      effectiveDate
      endDate
      assignedBy
      assignmentReason
      changeReason
      employeeNameSnapshot
      orgUnitNameSnapshot
      roleSnapshot
      createdAt
      lastModified
      changedBy
      updatedAt
      __typename
    }
  }
`;
export const listOrgUnitEmployees = /* GraphQL */ `
  query ListOrgUnitEmployees(
    $filter: ModelOrgUnitEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrgUnitEmployees(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        employeeId
        orgUnitId
        managementLevel
        roleDefinitionId
        isActive
        effectiveDate
        endDate
        assignedBy
        assignmentReason
        changeReason
        employeeNameSnapshot
        orgUnitNameSnapshot
        roleSnapshot
        createdAt
        lastModified
        changedBy
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const orgUnitEmployeesByClient = /* GraphQL */ `
  query OrgUnitEmployeesByClient(
    $clientId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelOrgUnitEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    orgUnitEmployeesByClient(
      clientId: $clientId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        employeeId
        orgUnitId
        managementLevel
        roleDefinitionId
        isActive
        effectiveDate
        endDate
        assignedBy
        assignmentReason
        changeReason
        employeeNameSnapshot
        orgUnitNameSnapshot
        roleSnapshot
        createdAt
        lastModified
        changedBy
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const orgUnitAssignmentsByEmployee = /* GraphQL */ `
  query OrgUnitAssignmentsByEmployee(
    $employeeId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelOrgUnitEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    orgUnitAssignmentsByEmployee(
      employeeId: $employeeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        employeeId
        orgUnitId
        managementLevel
        roleDefinitionId
        isActive
        effectiveDate
        endDate
        assignedBy
        assignmentReason
        changeReason
        employeeNameSnapshot
        orgUnitNameSnapshot
        roleSnapshot
        createdAt
        lastModified
        changedBy
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const orgUnitEmployeesByOrgUnit = /* GraphQL */ `
  query OrgUnitEmployeesByOrgUnit(
    $orgUnitId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelOrgUnitEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    orgUnitEmployeesByOrgUnit(
      orgUnitId: $orgUnitId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        employeeId
        orgUnitId
        managementLevel
        roleDefinitionId
        isActive
        effectiveDate
        endDate
        assignedBy
        assignmentReason
        changeReason
        employeeNameSnapshot
        orgUnitNameSnapshot
        roleSnapshot
        createdAt
        lastModified
        changedBy
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBulkOperation = /* GraphQL */ `
  query GetBulkOperation($id: ID!) {
    getBulkOperation(id: $id) {
      id
      clientId
      operationType
      status
      totalRecords
      processedRecords
      failedRecords
      progressPercent
      errorSummary
      errorDetails
      operationData
      previewData
      canUndo
      undoOperationId
      undoReason
      initiatedBy
      initiatedByName
      startedAt
      estimatedCompletion
      completedAt
      notificationsSent
      completionEmailSent
      description
      changeReason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBulkOperations = /* GraphQL */ `
  query ListBulkOperations(
    $filter: ModelBulkOperationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBulkOperations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        clientId
        operationType
        status
        totalRecords
        processedRecords
        failedRecords
        progressPercent
        errorSummary
        errorDetails
        operationData
        previewData
        canUndo
        undoOperationId
        undoReason
        initiatedBy
        initiatedByName
        startedAt
        estimatedCompletion
        completedAt
        notificationsSent
        completionEmailSent
        description
        changeReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const bulkOperationsByClient = /* GraphQL */ `
  query BulkOperationsByClient(
    $clientId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelBulkOperationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bulkOperationsByClient(
      clientId: $clientId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        operationType
        status
        totalRecords
        processedRecords
        failedRecords
        progressPercent
        errorSummary
        errorDetails
        operationData
        previewData
        canUndo
        undoOperationId
        undoReason
        initiatedBy
        initiatedByName
        startedAt
        estimatedCompletion
        completedAt
        notificationsSent
        completionEmailSent
        description
        changeReason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getHierarchyChangeLog = /* GraphQL */ `
  query GetHierarchyChangeLog($id: ID!) {
    getHierarchyChangeLog(id: $id) {
      id
      clientId
      changeType
      affectedLocations
      affectedOrgUnits
      changeDetails {
        entityType
        entityId
        entityName
        operationType
        fieldChanges {
          fieldName
          oldValue
          oldDisplayValue
          newValue
          newDisplayValue
          __typename
        }
        metadata
        __typename
      }
      changeSummary
      changeReason
      changedBy
      changedByName
      changedAt
      bulkOperationId
      snapshotId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listHierarchyChangeLogs = /* GraphQL */ `
  query ListHierarchyChangeLogs(
    $filter: ModelHierarchyChangeLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHierarchyChangeLogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        changeType
        affectedLocations
        affectedOrgUnits
        changeDetails {
          entityType
          entityId
          entityName
          operationType
          fieldChanges {
            fieldName
            oldValue
            oldDisplayValue
            newValue
            newDisplayValue
            __typename
          }
          metadata
          __typename
        }
        changeSummary
        changeReason
        changedBy
        changedByName
        changedAt
        bulkOperationId
        snapshotId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const hierarchyChangesByClient = /* GraphQL */ `
  query HierarchyChangesByClient(
    $clientId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelHierarchyChangeLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    hierarchyChangesByClient(
      clientId: $clientId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        changeType
        affectedLocations
        affectedOrgUnits
        changeDetails {
          entityType
          entityId
          entityName
          operationType
          fieldChanges {
            fieldName
            oldValue
            oldDisplayValue
            newValue
            newDisplayValue
            __typename
          }
          metadata
          __typename
        }
        changeSummary
        changeReason
        changedBy
        changedByName
        changedAt
        bulkOperationId
        snapshotId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getHierarchySnapshot = /* GraphQL */ `
  query GetHierarchySnapshot($id: ID!) {
    getHierarchySnapshot(id: $id) {
      id
      clientId
      snapshotDate
      locations {
        locationId
        locationName
        orgLevel_1
        orgLevel_1_name
        orgLevel_2
        orgLevel_2_name
        orgLevel_3
        orgLevel_3_name
        laborTargets {
          fohBaseHours {
            Mon
            Tue
            Wed
            Thu
            Fri
            Sat
            Sun
            __typename
          }
          bohBaseHours {
            Mon
            Tue
            Wed
            Thu
            Fri
            Sat
            Sun
            __typename
          }
          fohVariableHours
          bohVariableHours
          salesBase
          effectiveDate
          __typename
        }
        isActive
        closeDate
        __typename
      }
      orgUnits {
        orgUnitId
        name
        orgLevel
        parentOrgUnitId
        parentOrgUnitName
        isActive
        __typename
      }
      hierarchyChangeLogId
      reason
      createdAt
      createdBy
      createdByName
      totalLocations
      totalOrgUnits
      snapshotType
      updatedAt
      __typename
    }
  }
`;
export const listHierarchySnapshots = /* GraphQL */ `
  query ListHierarchySnapshots(
    $filter: ModelHierarchySnapshotFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHierarchySnapshots(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        snapshotDate
        locations {
          locationId
          locationName
          orgLevel_1
          orgLevel_1_name
          orgLevel_2
          orgLevel_2_name
          orgLevel_3
          orgLevel_3_name
          laborTargets {
            fohBaseHours {
              Mon
              Tue
              Wed
              Thu
              Fri
              Sat
              Sun
              __typename
            }
            bohBaseHours {
              Mon
              Tue
              Wed
              Thu
              Fri
              Sat
              Sun
              __typename
            }
            fohVariableHours
            bohVariableHours
            salesBase
            effectiveDate
            __typename
          }
          isActive
          closeDate
          __typename
        }
        orgUnits {
          orgUnitId
          name
          orgLevel
          parentOrgUnitId
          parentOrgUnitName
          isActive
          __typename
        }
        hierarchyChangeLogId
        reason
        createdAt
        createdBy
        createdByName
        totalLocations
        totalOrgUnits
        snapshotType
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const hierarchySnapshotsByClientDate = /* GraphQL */ `
  query HierarchySnapshotsByClientDate(
    $clientId: String!
    $snapshotDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelHierarchySnapshotFilterInput
    $limit: Int
    $nextToken: String
  ) {
    hierarchySnapshotsByClientDate(
      clientId: $clientId
      snapshotDate: $snapshotDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        snapshotDate
        locations {
          locationId
          locationName
          orgLevel_1
          orgLevel_1_name
          orgLevel_2
          orgLevel_2_name
          orgLevel_3
          orgLevel_3_name
          laborTargets {
            fohBaseHours {
              Mon
              Tue
              Wed
              Thu
              Fri
              Sat
              Sun
              __typename
            }
            bohBaseHours {
              Mon
              Tue
              Wed
              Thu
              Fri
              Sat
              Sun
              __typename
            }
            fohVariableHours
            bohVariableHours
            salesBase
            effectiveDate
            __typename
          }
          isActive
          closeDate
          __typename
        }
        orgUnits {
          orgUnitId
          name
          orgLevel
          parentOrgUnitId
          parentOrgUnitName
          isActive
          __typename
        }
        hierarchyChangeLogId
        reason
        createdAt
        createdBy
        createdByName
        totalLocations
        totalOrgUnits
        snapshotType
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const hierarchySnapshotsByDate = /* GraphQL */ `
  query HierarchySnapshotsByDate(
    $snapshotDate: AWSDateTime!
    $sortDirection: ModelSortDirection
    $filter: ModelHierarchySnapshotFilterInput
    $limit: Int
    $nextToken: String
  ) {
    hierarchySnapshotsByDate(
      snapshotDate: $snapshotDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        snapshotDate
        locations {
          locationId
          locationName
          orgLevel_1
          orgLevel_1_name
          orgLevel_2
          orgLevel_2_name
          orgLevel_3
          orgLevel_3_name
          laborTargets {
            fohBaseHours {
              Mon
              Tue
              Wed
              Thu
              Fri
              Sat
              Sun
              __typename
            }
            bohBaseHours {
              Mon
              Tue
              Wed
              Thu
              Fri
              Sat
              Sun
              __typename
            }
            fohVariableHours
            bohVariableHours
            salesBase
            effectiveDate
            __typename
          }
          isActive
          closeDate
          __typename
        }
        orgUnits {
          orgUnitId
          name
          orgLevel
          parentOrgUnitId
          parentOrgUnitName
          isActive
          __typename
        }
        hierarchyChangeLogId
        reason
        createdAt
        createdBy
        createdByName
        totalLocations
        totalOrgUnits
        snapshotType
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getHierarchyConstraint = /* GraphQL */ `
  query GetHierarchyConstraint($id: ID!) {
    getHierarchyConstraint(id: $id) {
      id
      clientId
      constraintType
      config
      targetLevel
      isActive
      enforcement
      name
      description
      createdBy
      createdAt
      changedBy
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const listHierarchyConstraints = /* GraphQL */ `
  query ListHierarchyConstraints(
    $filter: ModelHierarchyConstraintFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHierarchyConstraints(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        constraintType
        config
        targetLevel
        isActive
        enforcement
        name
        description
        createdBy
        createdAt
        changedBy
        lastModified
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const constraintsByClient = /* GraphQL */ `
  query ConstraintsByClient(
    $clientId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelHierarchyConstraintFilterInput
    $limit: Int
    $nextToken: String
  ) {
    constraintsByClient(
      clientId: $clientId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        constraintType
        config
        targetLevel
        isActive
        enforcement
        name
        description
        createdBy
        createdAt
        changedBy
        lastModified
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTagCatalog = /* GraphQL */ `
  query GetTagCatalog($id: ID!) {
    getTagCatalog(id: $id) {
      id
      clientId
      applicableTypes
      category
      label
      value
      description
      isActive
      isSystem
      metadata
      createdBy
      createdAt
      changedBy
      lastModified
      updatedAt
      __typename
    }
  }
`;
export const listTagCatalogs = /* GraphQL */ `
  query ListTagCatalogs(
    $filter: ModelTagCatalogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTagCatalogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        clientId
        applicableTypes
        category
        label
        value
        description
        isActive
        isSystem
        metadata
        createdBy
        createdAt
        changedBy
        lastModified
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const tagCatalogByClientCategory = /* GraphQL */ `
  query TagCatalogByClientCategory(
    $clientId: String!
    $categoryLabel: ModelTagCatalogByClientCategoryCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTagCatalogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    tagCatalogByClientCategory(
      clientId: $clientId
      categoryLabel: $categoryLabel
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        applicableTypes
        category
        label
        value
        description
        isActive
        isSystem
        metadata
        createdBy
        createdAt
        changedBy
        lastModified
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTagAssignment = /* GraphQL */ `
  query GetTagAssignment($id: ID!) {
    getTagAssignment(id: $id) {
      id
      clientId
      entityType
      entityId
      tagCatalogId
      tagLabel
      tagCategory
      assignedBy
      assignedAt
      isActive
      context
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTagAssignments = /* GraphQL */ `
  query ListTagAssignments(
    $filter: ModelTagAssignmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTagAssignments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        clientId
        entityType
        entityId
        tagCatalogId
        tagLabel
        tagCategory
        assignedBy
        assignedAt
        isActive
        context
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const tagAssignmentsByClientEntity = /* GraphQL */ `
  query TagAssignmentsByClientEntity(
    $clientId: String!
    $entityTypeEntityId: ModelTagAssignmentByClientEntityCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTagAssignmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    tagAssignmentsByClientEntity(
      clientId: $clientId
      entityTypeEntityId: $entityTypeEntityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        entityType
        entityId
        tagCatalogId
        tagLabel
        tagCategory
        assignedBy
        assignedAt
        isActive
        context
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const tagAssignmentsByEntity = /* GraphQL */ `
  query TagAssignmentsByEntity(
    $entityId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTagAssignmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    tagAssignmentsByEntity(
      entityId: $entityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        entityType
        entityId
        tagCatalogId
        tagLabel
        tagCategory
        assignedBy
        assignedAt
        isActive
        context
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const tagAssignmentsByTag = /* GraphQL */ `
  query TagAssignmentsByTag(
    $tagCatalogId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTagAssignmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    tagAssignmentsByTag(
      tagCatalogId: $tagCatalogId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        entityType
        entityId
        tagCatalogId
        tagLabel
        tagCategory
        assignedBy
        assignedAt
        isActive
        context
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      client
      userName
      firstName
      lastName
      email
      role
      group
      groupRole
      employeeId
      status
      securityVersion
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        client
        userName
        firstName
        lastName
        email
        role
        group
        groupRole
        employeeId
        status
        securityVersion
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getResourceType = /* GraphQL */ `
  query GetResourceType($id: ID!) {
    getResourceType(id: $id) {
      id
      name
      resourcePrefix
      icon
      description
      status
      domainRestrictions
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listResourceTypes = /* GraphQL */ `
  query ListResourceTypes(
    $filter: ModelResourceTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listResourceTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        resourcePrefix
        icon
        description
        status
        domainRestrictions
        metadata
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getResourceCatalog = /* GraphQL */ `
  query GetResourceCatalog($id: ID!) {
    getResourceCatalog(id: $id) {
      id
      resourceCode
      resourceTypeId
      domain
      name
      description
      icon
      route
      componentPath
      defaultActions
      status
      version
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listResourceCatalogs = /* GraphQL */ `
  query ListResourceCatalogs(
    $filter: ModelResourceCatalogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listResourceCatalogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        resourceCode
        resourceTypeId
        domain
        name
        description
        icon
        route
        componentPath
        defaultActions
        status
        version
        metadata
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const resourceCatalogByResourceCode = /* GraphQL */ `
  query ResourceCatalogByResourceCode(
    $resourceCode: String!
    $sortDirection: ModelSortDirection
    $filter: ModelResourceCatalogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    resourceCatalogByResourceCode(
      resourceCode: $resourceCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        resourceCode
        resourceTypeId
        domain
        name
        description
        icon
        route
        componentPath
        defaultActions
        status
        version
        metadata
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const resourceCatalogByType = /* GraphQL */ `
  query ResourceCatalogByType(
    $resourceTypeId: ID!
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelResourceCatalogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    resourceCatalogByType(
      resourceTypeId: $resourceTypeId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        resourceCode
        resourceTypeId
        domain
        name
        description
        icon
        route
        componentPath
        defaultActions
        status
        version
        metadata
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const resourceCatalogByStatus = /* GraphQL */ `
  query ResourceCatalogByStatus(
    $status: ResourceStatus!
    $sortDirection: ModelSortDirection
    $filter: ModelResourceCatalogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    resourceCatalogByStatus(
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        resourceCode
        resourceTypeId
        domain
        name
        description
        icon
        route
        componentPath
        defaultActions
        status
        version
        metadata
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getClientResourceMap = /* GraphQL */ `
  query GetClientResourceMap($id: ID!) {
    getClientResourceMap(id: $id) {
      id
      clientId
      resourceId
      isEnabled
      customLabel
      customTooltip
      customDescription
      customIcon
      allowedActionsOverride
      order
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listClientResourceMaps = /* GraphQL */ `
  query ListClientResourceMaps(
    $filter: ModelClientResourceMapFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listClientResourceMaps(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        resourceId
        isEnabled
        customLabel
        customTooltip
        customDescription
        customIcon
        allowedActionsOverride
        order
        metadata
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const clientResourceMapByClient = /* GraphQL */ `
  query ClientResourceMapByClient(
    $clientId: String!
    $order: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelClientResourceMapFilterInput
    $limit: Int
    $nextToken: String
  ) {
    clientResourceMapByClient(
      clientId: $clientId
      order: $order
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        resourceId
        isEnabled
        customLabel
        customTooltip
        customDescription
        customIcon
        allowedActionsOverride
        order
        metadata
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const clientResourceMapByResource = /* GraphQL */ `
  query ClientResourceMapByResource(
    $resourceId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelClientResourceMapFilterInput
    $limit: Int
    $nextToken: String
  ) {
    clientResourceMapByResource(
      resourceId: $resourceId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        resourceId
        isEnabled
        customLabel
        customTooltip
        customDescription
        customIcon
        allowedActionsOverride
        order
        metadata
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserEmployee = /* GraphQL */ `
  query GetUserEmployee($id: ID!) {
    getUserEmployee(id: $id) {
      id
      userId
      employeeId
      client
      linkedAt
      linkedBy
      unlinkedAt
      unlinkedBy
      isActive
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserEmployees = /* GraphQL */ `
  query ListUserEmployees(
    $filter: ModelUserEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserEmployees(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        employeeId
        client
        linkedAt
        linkedBy
        unlinkedAt
        unlinkedBy
        isActive
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getGrant = /* GraphQL */ `
  query GetGrant($id: ID!) {
    getGrant(id: $id) {
      id
      clientId
      name
      description
      targetDomain
      targetResourceTypeId
      targetResourceId
      targetResourcePattern
      subjectType
      subjectValue
      actionConfigs {
        action
        effect
        scopeConfig {
          includeChildren
          includePeers
          includeParent
          __typename
        }
        constraints
        priority
        __typename
      }
      priority
      constraints
      effectiveFrom
      effectiveTo
      isActive
      createdAt
      updatedAt
      createdBy
      updatedBy
      grantSignature
      __typename
    }
  }
`;
export const listGrants = /* GraphQL */ `
  query ListGrants(
    $filter: ModelGrantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGrants(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        clientId
        name
        description
        targetDomain
        targetResourceTypeId
        targetResourceId
        targetResourcePattern
        subjectType
        subjectValue
        actionConfigs {
          action
          effect
          scopeConfig {
            includeChildren
            includePeers
            includeParent
            __typename
          }
          constraints
          priority
          __typename
        }
        priority
        constraints
        effectiveFrom
        effectiveTo
        isActive
        createdAt
        updatedAt
        createdBy
        updatedBy
        grantSignature
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const grantsByResourceType = /* GraphQL */ `
  query GrantsByResourceType(
    $targetResourceTypeId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelGrantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    grantsByResourceType(
      targetResourceTypeId: $targetResourceTypeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        name
        description
        targetDomain
        targetResourceTypeId
        targetResourceId
        targetResourcePattern
        subjectType
        subjectValue
        actionConfigs {
          action
          effect
          scopeConfig {
            includeChildren
            includePeers
            includeParent
            __typename
          }
          constraints
          priority
          __typename
        }
        priority
        constraints
        effectiveFrom
        effectiveTo
        isActive
        createdAt
        updatedAt
        createdBy
        updatedBy
        grantSignature
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const grantsByResource = /* GraphQL */ `
  query GrantsByResource(
    $targetResourceId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelGrantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    grantsByResource(
      targetResourceId: $targetResourceId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        name
        description
        targetDomain
        targetResourceTypeId
        targetResourceId
        targetResourcePattern
        subjectType
        subjectValue
        actionConfigs {
          action
          effect
          scopeConfig {
            includeChildren
            includePeers
            includeParent
            __typename
          }
          constraints
          priority
          __typename
        }
        priority
        constraints
        effectiveFrom
        effectiveTo
        isActive
        createdAt
        updatedAt
        createdBy
        updatedBy
        grantSignature
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const grantBySignature = /* GraphQL */ `
  query GrantBySignature(
    $grantSignature: String!
    $sortDirection: ModelSortDirection
    $filter: ModelGrantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    grantBySignature(
      grantSignature: $grantSignature
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        name
        description
        targetDomain
        targetResourceTypeId
        targetResourceId
        targetResourcePattern
        subjectType
        subjectValue
        actionConfigs {
          action
          effect
          scopeConfig {
            includeChildren
            includePeers
            includeParent
            __typename
          }
          constraints
          priority
          __typename
        }
        priority
        constraints
        effectiveFrom
        effectiveTo
        isActive
        createdAt
        updatedAt
        createdBy
        updatedBy
        grantSignature
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserPermissionsCache = /* GraphQL */ `
  query GetUserPermissionsCache($id: ID!) {
    getUserPermissionsCache(id: $id) {
      id
      clientId
      userId
      group
      groupRole
      permissions
      navigation
      dataScope {
        scopeType
        assignedLocations
        assignedOrgUnits
        accessibleLocations
        accessibleOrgUnits
        includeChildren
        includePeers
        includeParent
        calculatedAt
        calculatedFrom
        __typename
      }
      version
      calculatedAt
      lastUsed
      securityVersion
      hash
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserPermissionsCaches = /* GraphQL */ `
  query ListUserPermissionsCaches(
    $filter: ModelUserPermissionsCacheFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserPermissionsCaches(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        userId
        group
        groupRole
        permissions
        navigation
        dataScope {
          scopeType
          assignedLocations
          assignedOrgUnits
          accessibleLocations
          accessibleOrgUnits
          includeChildren
          includePeers
          includeParent
          calculatedAt
          calculatedFrom
          __typename
        }
        version
        calculatedAt
        lastUsed
        securityVersion
        hash
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userPermissionsCacheByUserId = /* GraphQL */ `
  query UserPermissionsCacheByUserId(
    $userId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserPermissionsCacheFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userPermissionsCacheByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        userId
        group
        groupRole
        permissions
        navigation
        dataScope {
          scopeType
          assignedLocations
          assignedOrgUnits
          accessibleLocations
          accessibleOrgUnits
          includeChildren
          includePeers
          includeParent
          calculatedAt
          calculatedFrom
          __typename
        }
        version
        calculatedAt
        lastUsed
        securityVersion
        hash
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMetricData = /* GraphQL */ `
  query GetMetricData($metricId: ID!) {
    getMetricData(metricId: $metricId) {
      metricId
      clientId
      storeId
      date
      hour
      frequency
      metricName
      metricType
      numberValue
      stringValue
      booleanValue
      dayPart
      diningOption
      source
      timestamp
      unit
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMetricData = /* GraphQL */ `
  query ListMetricData(
    $metricId: ID
    $filter: ModelMetricDataFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listMetricData(
      metricId: $metricId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        metricId
        clientId
        storeId
        date
        hour
        frequency
        metricName
        metricType
        numberValue
        stringValue
        booleanValue
        dayPart
        diningOption
        source
        timestamp
        unit
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const metricDataByClientStoreDateMetric = /* GraphQL */ `
  query MetricDataByClientStoreDateMetric(
    $clientId: ID!
    $storeIdDateMetricName: ModelMetricDataByClientStoreDateMetricCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMetricDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    metricDataByClientStoreDateMetric(
      clientId: $clientId
      storeIdDateMetricName: $storeIdDateMetricName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        metricId
        clientId
        storeId
        date
        hour
        frequency
        metricName
        metricType
        numberValue
        stringValue
        booleanValue
        dayPart
        diningOption
        source
        timestamp
        unit
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const metricDataByClientDate = /* GraphQL */ `
  query MetricDataByClientDate(
    $clientId: ID!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMetricDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    metricDataByClientDate(
      clientId: $clientId
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        metricId
        clientId
        storeId
        date
        hour
        frequency
        metricName
        metricType
        numberValue
        stringValue
        booleanValue
        dayPart
        diningOption
        source
        timestamp
        unit
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const metricDataByDate = /* GraphQL */ `
  query MetricDataByDate(
    $date: AWSDate!
    $clientIdStoreId: ModelMetricDataByDateCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMetricDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    metricDataByDate(
      date: $date
      clientIdStoreId: $clientIdStoreId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        metricId
        clientId
        storeId
        date
        hour
        frequency
        metricName
        metricType
        numberValue
        stringValue
        booleanValue
        dayPart
        diningOption
        source
        timestamp
        unit
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getThreshold = /* GraphQL */ `
  query GetThreshold($id: ID!) {
    getThreshold(id: $id) {
      id
      clientId
      name
      entityType
      entityId
      metric
      thresholdType
      thresholdBands {
        position
        operator
        numberValue
        textValue
        backgroundColor
        color
        fontWeight
        fontStyle
        borderColor
        borderWidth
        icon
        text
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listThresholds = /* GraphQL */ `
  query ListThresholds(
    $filter: ModelThresholdFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listThresholds(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        clientId
        name
        entityType
        entityId
        metric
        thresholdType
        thresholdBands {
          position
          operator
          numberValue
          textValue
          backgroundColor
          color
          fontWeight
          fontStyle
          borderColor
          borderWidth
          icon
          text
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getThresholdMapping = /* GraphQL */ `
  query GetThresholdMapping($id: ID!) {
    getThresholdMapping(id: $id) {
      id
      entityId
      extEntityId
      thresholdId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listThresholdMappings = /* GraphQL */ `
  query ListThresholdMappings(
    $filter: ModelThresholdMappingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listThresholdMappings(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        entityId
        extEntityId
        thresholdId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getControlTable = /* GraphQL */ `
  query GetControlTable($taskId: String!) {
    getControlTable(taskId: $taskId) {
      taskId
      executionId
      jobDefinitionId
      clientId
      dataSource
      dataCategory
      sourceIdentifier
      timeRangeStart
      timeRangeEnd
      status
      recordsProcessed
      startTime
      endTime
      processingDuration
      errorDetails
      retryCount
      validationStatus
      validationDiscrepancies
      validationNotes
      priority
      lastUpdated
      createdBy
      version
      parentTaskId
      clientDataSource
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listControlTables = /* GraphQL */ `
  query ListControlTables(
    $taskId: String
    $filter: ModelControlTableFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listControlTables(
      taskId: $taskId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        taskId
        executionId
        jobDefinitionId
        clientId
        dataSource
        dataCategory
        sourceIdentifier
        timeRangeStart
        timeRangeEnd
        status
        recordsProcessed
        startTime
        endTime
        processingDuration
        errorDetails
        retryCount
        validationStatus
        validationDiscrepancies
        validationNotes
        priority
        lastUpdated
        createdBy
        version
        parentTaskId
        clientDataSource
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const controlTableByExecutionStatus = /* GraphQL */ `
  query ControlTableByExecutionStatus(
    $executionId: String!
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelControlTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    controlTableByExecutionStatus(
      executionId: $executionId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        taskId
        executionId
        jobDefinitionId
        clientId
        dataSource
        dataCategory
        sourceIdentifier
        timeRangeStart
        timeRangeEnd
        status
        recordsProcessed
        startTime
        endTime
        processingDuration
        errorDetails
        retryCount
        validationStatus
        validationDiscrepancies
        validationNotes
        priority
        lastUpdated
        createdBy
        version
        parentTaskId
        clientDataSource
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const controlTableByJobDefinition = /* GraphQL */ `
  query ControlTableByJobDefinition(
    $jobDefinitionId: String!
    $startTime: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelControlTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    controlTableByJobDefinition(
      jobDefinitionId: $jobDefinitionId
      startTime: $startTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        taskId
        executionId
        jobDefinitionId
        clientId
        dataSource
        dataCategory
        sourceIdentifier
        timeRangeStart
        timeRangeEnd
        status
        recordsProcessed
        startTime
        endTime
        processingDuration
        errorDetails
        retryCount
        validationStatus
        validationDiscrepancies
        validationNotes
        priority
        lastUpdated
        createdBy
        version
        parentTaskId
        clientDataSource
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const controlTableByClient = /* GraphQL */ `
  query ControlTableByClient(
    $clientId: String!
    $lastUpdated: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelControlTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    controlTableByClient(
      clientId: $clientId
      lastUpdated: $lastUpdated
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        taskId
        executionId
        jobDefinitionId
        clientId
        dataSource
        dataCategory
        sourceIdentifier
        timeRangeStart
        timeRangeEnd
        status
        recordsProcessed
        startTime
        endTime
        processingDuration
        errorDetails
        retryCount
        validationStatus
        validationDiscrepancies
        validationNotes
        priority
        lastUpdated
        createdBy
        version
        parentTaskId
        clientDataSource
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const controlTableBySourceTimeRange = /* GraphQL */ `
  query ControlTableBySourceTimeRange(
    $sourceIdentifier: String!
    $timeRangeStart: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelControlTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    controlTableBySourceTimeRange(
      sourceIdentifier: $sourceIdentifier
      timeRangeStart: $timeRangeStart
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        taskId
        executionId
        jobDefinitionId
        clientId
        dataSource
        dataCategory
        sourceIdentifier
        timeRangeStart
        timeRangeEnd
        status
        recordsProcessed
        startTime
        endTime
        processingDuration
        errorDetails
        retryCount
        validationStatus
        validationDiscrepancies
        validationNotes
        priority
        lastUpdated
        createdBy
        version
        parentTaskId
        clientDataSource
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const controlTableByStatusLastUpdated = /* GraphQL */ `
  query ControlTableByStatusLastUpdated(
    $status: TaskStatus!
    $lastUpdated: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelControlTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    controlTableByStatusLastUpdated(
      status: $status
      lastUpdated: $lastUpdated
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        taskId
        executionId
        jobDefinitionId
        clientId
        dataSource
        dataCategory
        sourceIdentifier
        timeRangeStart
        timeRangeEnd
        status
        recordsProcessed
        startTime
        endTime
        processingDuration
        errorDetails
        retryCount
        validationStatus
        validationDiscrepancies
        validationNotes
        priority
        lastUpdated
        createdBy
        version
        parentTaskId
        clientDataSource
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const controlTableByClientDataSource = /* GraphQL */ `
  query ControlTableByClientDataSource(
    $clientDataSource: String!
    $dataCategory: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelControlTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    controlTableByClientDataSource(
      clientDataSource: $clientDataSource
      dataCategory: $dataCategory
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        taskId
        executionId
        jobDefinitionId
        clientId
        dataSource
        dataCategory
        sourceIdentifier
        timeRangeStart
        timeRangeEnd
        status
        recordsProcessed
        startTime
        endTime
        processingDuration
        errorDetails
        retryCount
        validationStatus
        validationDiscrepancies
        validationNotes
        priority
        lastUpdated
        createdBy
        version
        parentTaskId
        clientDataSource
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getJobDefinition = /* GraphQL */ `
  query GetJobDefinition($jobDefinitionId: String!) {
    getJobDefinition(jobDefinitionId: $jobDefinitionId) {
      jobDefinitionId
      name
      description
      clientId
      dataSource
      sourceEndpoint
      sourceFilters {
        name
        values
        __typename
      }
      dataTimeConfig {
        mode
        relativeValue
        relativeUnit
        offset
        startDateTime
        endDateTime
        granularity
        __typename
      }
      scheduleConfig {
        mode
        cronExpression
        timeZoneStrategy
        specificTimeZone
        scheduleStartDate
        scheduleEndDate
        scheduledTime
        __typename
      }
      status
      createdBy
      createdAt
      lastModified
      settings
      clientDataSource
      updatedAt
      __typename
    }
  }
`;
export const listJobDefinitions = /* GraphQL */ `
  query ListJobDefinitions(
    $jobDefinitionId: String
    $filter: ModelJobDefinitionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listJobDefinitions(
      jobDefinitionId: $jobDefinitionId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        jobDefinitionId
        name
        description
        clientId
        dataSource
        sourceEndpoint
        sourceFilters {
          name
          values
          __typename
        }
        dataTimeConfig {
          mode
          relativeValue
          relativeUnit
          offset
          startDateTime
          endDateTime
          granularity
          __typename
        }
        scheduleConfig {
          mode
          cronExpression
          timeZoneStrategy
          specificTimeZone
          scheduleStartDate
          scheduleEndDate
          scheduledTime
          __typename
        }
        status
        createdBy
        createdAt
        lastModified
        settings
        clientDataSource
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getJobExecution = /* GraphQL */ `
  query GetJobExecution($executionId: String!) {
    getJobExecution(executionId: $executionId) {
      executionId
      jobDefinitionId
      executionNumber
      clientId
      timeRangeStart
      timeRangeEnd
      status
      startTime
      endTime
      tasksTotal
      tasksSucceeded
      tasksFailed
      recordsProcessed
      triggeredBy
      lastUpdated
      errorSummary
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listJobExecutions = /* GraphQL */ `
  query ListJobExecutions(
    $executionId: String
    $filter: ModelJobExecutionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listJobExecutions(
      executionId: $executionId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        executionId
        jobDefinitionId
        executionNumber
        clientId
        timeRangeStart
        timeRangeEnd
        status
        startTime
        endTime
        tasksTotal
        tasksSucceeded
        tasksFailed
        recordsProcessed
        triggeredBy
        lastUpdated
        errorSummary
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDemoBaseline = /* GraphQL */ `
  query GetDemoBaseline($clientId: String!) {
    getDemoBaseline(clientId: $clientId) {
      clientId
      auv
      avgCheck
      laborPct
      fohWage
      bohWage
      fohBohSplit
      noiseSigma
      baseSeed
      defaultSeasonalityKey
      defaultWeekdayProfileKey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDemoBaselines = /* GraphQL */ `
  query ListDemoBaselines(
    $clientId: String
    $filter: ModelDemoBaselineFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDemoBaselines(
      clientId: $clientId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        clientId
        auv
        avgCheck
        laborPct
        fohWage
        bohWage
        fohBohSplit
        noiseSigma
        baseSeed
        defaultSeasonalityKey
        defaultWeekdayProfileKey
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDemoSeasonality = /* GraphQL */ `
  query GetDemoSeasonality($seasonalityKey: String!) {
    getDemoSeasonality(seasonalityKey: $seasonalityKey) {
      seasonalityKey
      monthly
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDemoSeasonalities = /* GraphQL */ `
  query ListDemoSeasonalities(
    $seasonalityKey: String
    $filter: ModelDemoSeasonalityFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDemoSeasonalities(
      seasonalityKey: $seasonalityKey
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        seasonalityKey
        monthly
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDemoWeekdayProfile = /* GraphQL */ `
  query GetDemoWeekdayProfile($profileKey: String!) {
    getDemoWeekdayProfile(profileKey: $profileKey) {
      profileKey
      weekday
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDemoWeekdayProfiles = /* GraphQL */ `
  query ListDemoWeekdayProfiles(
    $profileKey: String
    $filter: ModelDemoWeekdayProfileFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDemoWeekdayProfiles(
      profileKey: $profileKey
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        profileKey
        weekday
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDemoUnitConfig = /* GraphQL */ `
  query GetDemoUnitConfig($clientId: String!, $entityId: ID!) {
    getDemoUnitConfig(clientId: $clientId, entityId: $entityId) {
      clientId
      entityId
      orgLevel
      salesMult
      avgCheckMult
      laborPctDelta
      wageMult
      seasonalityKey
      weekdayProfileKey
      throughputCap
      tags
      notes
      effectiveFrom
      effectiveTo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDemoUnitConfigs = /* GraphQL */ `
  query ListDemoUnitConfigs(
    $clientId: String
    $entityId: ModelIDKeyConditionInput
    $filter: ModelDemoUnitConfigFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDemoUnitConfigs(
      clientId: $clientId
      entityId: $entityId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        clientId
        entityId
        orgLevel
        salesMult
        avgCheckMult
        laborPctDelta
        wageMult
        seasonalityKey
        weekdayProfileKey
        throughputCap
        tags
        notes
        effectiveFrom
        effectiveTo
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDemoAtomicShiftDaily = /* GraphQL */ `
  query GetDemoAtomicShiftDaily($id: ID!) {
    getDemoAtomicShiftDaily(id: $id) {
      clientId
      locationId
      date
      shift
      netSales
      checkCount
      fohDollars
      bohDollars
      fohHours
      bohHours
      splh
      laborPct
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDemoAtomicShiftDailies = /* GraphQL */ `
  query ListDemoAtomicShiftDailies(
    $id: ID
    $filter: ModelDemoAtomicShiftDailyFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDemoAtomicShiftDailies(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        clientId
        locationId
        date
        shift
        netSales
        checkCount
        fohDollars
        bohDollars
        fohHours
        bohHours
        splh
        laborPct
        id
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const demoAtomicByClientDate = /* GraphQL */ `
  query DemoAtomicByClientDate(
    $clientId: String!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDemoAtomicShiftDailyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    demoAtomicByClientDate(
      clientId: $clientId
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        clientId
        locationId
        date
        shift
        netSales
        checkCount
        fohDollars
        bohDollars
        fohHours
        bohHours
        splh
        laborPct
        id
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDemoRun = /* GraphQL */ `
  query GetDemoRun($clientId: String!, $runId: ID!) {
    getDemoRun(clientId: $clientId, runId: $runId) {
      clientId
      runId
      operation
      scopeType
      scopeId
      startDate
      endDate
      seasonalityKey
      weekdayProfileKey
      baseSeed
      noiseSigma
      status
      startedAt
      endedAt
      writtenAtomic
      deletedAtomic
      lastLogLine
      errorMessage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDemoRuns = /* GraphQL */ `
  query ListDemoRuns(
    $clientId: String
    $runId: ModelIDKeyConditionInput
    $filter: ModelDemoRunFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDemoRuns(
      clientId: $clientId
      runId: $runId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        clientId
        runId
        operation
        scopeType
        scopeId
        startDate
        endDate
        seasonalityKey
        weekdayProfileKey
        baseSeed
        noiseSigma
        status
        startedAt
        endedAt
        writtenAtomic
        deletedAtomic
        lastLogLine
        errorMessage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
